export const WithdrawReason = [
  `Curriclum: Not academic enough`,
  `Curriclum: Too Academic`,
  `Curriclum: Quality of the teaching and learning`,
  `Curriclum: Quality and Frequency of assessments and feedback`,
  `Curriclum: Not enough sports in timetable`,
  `Curriclum: Preparation for Primary School`,
  `Curriclum: Unable to provide learning support`,
  `Facilities: Not enough Sports`,
  `Facilities: Not enough outdoor space`,
  `Facilities: Not enough communal spaces (library, auditorium, dining)`,
  `Facilities: Not enough IT resources`,
  `Fees: Increased too much`,
  `Fees: Change in financial situation`,
  `Fees: Looking for cheaper school`,
  `Language: Want more Language learning time`,
  `Language: Not happy with language acquisition`,
  `Language: More options`,
  `Logistics: Need longer School hours`,
  `Logistics: No bus service`,
  `Logistics: Not a good selection of After school Activities`,
  `Logistics: Too many holidays in Academic Year`,
  `Logistics: No Childcare options`,
  `School Community: Not diverse enough`,
  `School Community: Not inclusive enough`,
  `School Community: Not enough Community feel`,
  `School philosophy: Disagree with Behavior guidance policies`,
  `School philosophy: Disagree with Classroom management`,
  `Staff: Issue with Staff Member`,
  `Staff: High Turnover`,
  `Other: School Transition: Need to secure place in Primary`,
  `Other: School Transition: Need to secure place in Secondary`,
  `Others`,
]

export const schoolList = [
  `Anglo-Chinese School`,
  `Ascensia International School`,
  `Astor International School`,
  `Australian International School`,
  `Avondale Grammer`,
  `Bluehouse`,
  `Brighton`,
  `Canadian International School`,
  `Chatsworth`,
  `Dimensions international College`,
  `Dover Court`,
  `DPS International School`,
  `Dulwich College`,
  `French International School`,
  `GEMS World Academy`,
  `German European International School`,
  `Global Indian School`,
  `International Community School`,
  `International School Singapore`,
  `Invictus`,
  `Japanese International School`,
  `Kiddiewinkie`,
  `Korean International School`,
  `Mindchamps`,
  `My First Campus`,
  `Nexus`,
  `North London Collegiate School`,
  `NPS International School`,
  `Odyssey The Global Preschool`,
  `Olympiad International School`,
  `One World`,
  `Overseas Family School`,
  `Shaw's`,
  `Singapore American School`,
  `St. Joseph International School`,
  `Stamford American International School`,
  `Superland`,
  `Swiss School`,
  `Tanglin Trust`,
  `Undeclared`,
  `UWCSEA`,
  `XCL American Academy`,
  `Others`,
]

export const schoolListMIS = [`Middleton Tampines`]

export const schoolListWithoutUndeclared = [
  `Anglo-Chinese School`,
  `Ascensia International School`,
  `Astor International School`,
  `Australian International School`,
  `Avondale Grammer`,
  `Bluehouse`,
  `Brighton`,
  `Canadian International School`,
  `Chatsworth`,
  `Dimensions international College`,
  `Dover Court`,
  `DPS International School`,
  `Dulwich College`,
  `French International School`,
  `GEMS World Academy`,
  `German European International School`,
  `Global Indian School`,
  `International Community School`,
  `International School Singapore`,
  `Invictus`,
  `Japanese International School`,
  `Kiddiewinkie`,
  `Korean International School`,
  `Mindchamps`,
  `My First Campus`,
  `Nexus`,
  `North London Collegiate School`,
  `NPS International School`,
  `Odyssey The Global Preschool`,
  `Olympiad International School`,
  `One World`,
  `Overseas Family School`,
  `Shaw's`,
  `Singapore American School`,
  `St. Joseph International School`,
  `Stamford American International School`,
  `Superland`,
  `Swiss School`,
  `Tanglin Trust`,
  `UWCSEA`,
  `XCL American Academy`,
  `Others`,
]

export const notSuitedSchoolList = [
  `Odyssey`,
  `Mindchamps`,
  `OFS`,
  `Nexus`,
  `SAIS`,
  `ISS`,
  `ICS`,
  `Dulwich`,
  `UWC`,
  `SAS`,
  `Tanglin Trust`,
  `CIS`,
  `Chatsworth`,
  `Dover Court`,
  `Middleton International School`,
  `Invictus`,
  `Other`,
]

export const countryList = [
  'Afghanistan',
  'Åland Islands',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia, Plurinational State of',
  'Bonaire, Sint Eustatius and Saba',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo',
  'Congo, the Democratic Republic of the',
  'Cook Islands',
  'Costa Rica',
  "Côte d'",
  'Croatia',
  'Cuba',
  'Curaçao',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands (Malvinas)',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See (Vatican City State)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran, Islamic Republic of',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  "Korea, Democratic People's Republic ",
  'Korea, Republic of',
  'Kuwait',
  'Kyrgyzstan',
  "Lao People's Democratic ",
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Macedonia, the former Yugoslav Republic of',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia, Federated States of',
  'Moldova, Republic of',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestinian Territory, Occupied',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Réunion',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'Saint Barthélemy',
  'Saint Helena, Ascension and Tristan da Cunha',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin (French part)',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Sint Maarten (Dutch part)',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Svalbard and Jan Mayen',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan, Province of China',
  'Tajikistan',
  'Tanzania, United Republic of',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'United States Minor Outlying Islands',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela, Bolivarian Republic of',
  'Viet Nam',
  'Virgin Islands, British',
  'Virgin Islands, U.S',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe',
]
